import React from 'react';
import { capabilityStats } from '../../data/company';
import { AnimatedCounter } from '../ui/AnimatedCounter';
export function StatsBand() {
  return <section className="bg-midnight py-20 text-white" data-id="element-287" data-mp="1jp93io5p22km">
      <div className="container-page grid gap-12 lg:grid-cols-12 lg:items-center" data-id="element-288" data-mp="1er7me8rtwdbs">
        <div className="lg:col-span-4" data-id="element-289" data-mp="1ar6xtvb0mlr0">
          <h2 className="font-display text-4xl font-semibold leading-tight" data-id="element-290" data-mp="1aq4afxcwj1fu">The breadth of our practice.</h2>
          <p className="mt-4 text-sm leading-relaxed text-white/60" data-id="element-291" data-mp="15svqbr870nby">
            These figures describe the services, sectors and team presented on this website. Placement and performance figures will be
            published only once verified.
          </p>
        </div>
        <dl className="grid grid-cols-2 gap-x-8 gap-y-10 lg:col-span-8 lg:grid-cols-4" data-id="element-292" data-mp="r3zh3queh49r">
          {capabilityStats.map(s => <div key={s.label} className="border-l border-gold/40 pl-5" data-id="element-293" data-mp="n35sev94vlft">
              <dt className="sr-only" data-id="element-294" data-mp="i3b5t3we5i0k">{s.label}</dt>
              <dd data-id="element-295" data-mp="274rbtjn514h9">
                <AnimatedCounter value={s.value} className="block font-display text-6xl font-semibold text-gold-300" data-id="element-296" data-mp="27494nryxt5uk" />
                <span className="mt-2 block text-sm text-white/70" data-id="element-297" data-mp="2bvzm0hwaktvh">{s.label}</span>
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}